<template>
  <div>
    <div class="box-container">
      <div class="d-flex justify-space-between mb-5">
        <div class="d-flex align-center">
          <v-icon color="indigo darken-1" class="mr-3" size="28">mdi-cog</v-icon>
          <h3 class="mb-0">NFT for Sale</h3>
        </div>
        <router-link :to="{name: 'storePurchasableCreate'}" class="router-link">
          <v-btn outlined color="indigo">
            Add
          </v-btn>
        </router-link>
      </div>

      <PurchasableList
          :storeAccount="storeAccount"
      >
        <template v-slot:topRightBtn="purchasable">
          <v-btn
              color="indigo darken-3"
              outlined
              fab
              x-small
              dark
              @click="editPurchasableHandle(purchasable)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
      </PurchasableList>
    </div>

    <PurchasableInfoEditDialog
        v-if="purchasableForEdit"
        :purchasable="purchasableForEdit"
        :onCloseDialogHandle="cancelPurchasableEditHandle"
    >
    </PurchasableInfoEditDialog>
  </div>
</template>

<script>

import store from "@/store";
import PurchasableList from "@/components/PurchasableList/PurchasableList";
import PurchasableInfoEditDialog from "@/views/StorePanel/Component/PurchasableInfoEditDialog";

export default {
  name: "Purchasable",
  components: {
    PurchasableList,
    PurchasableInfoEditDialog
  },
  computed: {
    storeAccount() {
      return store.state.loggedInAccount
    }
  },
  data() {
    return {
      purchasableForEdit: null
    }
  },
  methods: {
    editPurchasableHandle(purchasable) {
      this.purchasableForEdit = purchasable
    },
    cancelPurchasableEditHandle() {
      this.purchasableForEdit = null
    }
  }
}
</script>

